// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1UCQe","dragIcon":"SortableItem_dragIcon__xwKAa","disabled":"SortableItem_disabled__3qTye"};